import { ConfigProvider } from 'antd';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { ampli } from '../../../ampli';
import { ErrorPage } from '../../../pages/etc/ErrorPage/ErrorPage';
import { LoadingPage } from '../../../pages/etc/LoadingPage/LoadingPage';
import { LayoutProvider } from '../../../provider/LayoutProvider';
import { ToastProvider } from '../../../provider/PopupProvider';
import { NotificationProvider } from '../../../provider/ToastNotificationProvider';
import { store } from '../../../store/store';
import { AppSetup } from './AppSetup';

export const AppBase = () => {
  const renderingErrorHandler = (error: Error) => {
    ampli.에러발생({
      '에러가 발생한 URL': window.location.href,
      '에러 내용': error.toString(),
      '에러 종류': '페이지 렌더링 실패',
    });
  };

  return (
    <Provider store={store}>
      <ToastProvider>
        <LayoutProvider>
          <ConfigProvider
            theme={{
              token: {
                colorBgMask: 'rgba(0,0,0,0.9)',
              },
            }}
          >
            <NotificationProvider>
              <ErrorBoundary fallback={<ErrorPage />} onError={(error) => renderingErrorHandler(error)}>
                <Suspense fallback={<LoadingPage />}>
                  <AppSetup />
                </Suspense>
              </ErrorBoundary>
            </NotificationProvider>
          </ConfigProvider>
        </LayoutProvider>
      </ToastProvider>
    </Provider>
  );
};
